<template>
    <div class="infoBlock">
        <div class="infoBlock-item">
            <span>Level 1</span>
            <span>{{ statisticsInfo['level_1'] }}</span>
        </div>
        <div class="infoBlock-item">
            <span>Level 2</span>
            <span>{{ statisticsInfo['level_2'] }}</span>
        </div>
        <div class="infoBlock-item">
            <span>Level 3</span>
            <span>{{ statisticsInfo['level_3'] }}</span>
        </div>
        <div class="infoBlock-item">
            <span>Total</span>
            <span>{{ statisticsInfo['total_truck'] }}</span>
        </div>
        <div class="infoBlock-item noBorder">
            <span>{{ title }} </span>
            <span>{{ statisticsInfo['under_repair'] }}</span>
        </div>
    </div>
</template>

<script>
export default {
	name: "Info",
	props: {
		statisticsInfo: Object,
		title: String
	}
};
</script>

<style scoped lang="scss">
@import "WOInfo";
</style>
